import styled from '@emotion/styled'

import { INLINES, BLOCKS } from '@contentful/rich-text-types'
import type { Document } from '@contentful/rich-text-types'

import Image from '@segment/matcha/components/Image'

import RichText from '@segment/matcha/recipes/RichText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import AutomaticallyMeasurePng2x from './assets/AutomaticallyMeasure@2x.png'
import AutomaticallyMeasureWebp from './assets/AutomaticallyMeasure.webp'
import AutomaticallyMeasureWebp2x from './assets/AutomaticallyMeasure@2x.webp'
import AutomaticallyMeasureWebp3x from './assets/AutomaticallyMeasure@3x.webp'

const copy = {
  heading: `Automatically measure user actions`,
}

const description = {
  content: [
    {
      content: [
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `Our mobile libraries, including `,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Swift`,
            },
          ],
          data: {
            uri: `/docs/connections/sources/catalog/libraries/mobile/swift-ios/`,
          },
          nodeType: INLINES.HYPERLINK,
        },
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: ` and `,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Kotlin`,
            },
          ],
          data: {
            uri: `/docs/connections/sources/catalog/libraries/mobile/kotlin-android/`,
          },
          nodeType: INLINES.HYPERLINK,
        },
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `, automatically collect essential events, so you can measure key mobile metrics 
without code and shrink your SDK with more server-to-server destinations.`,
        },
      ],
      data: {},
      nodeType: BLOCKS.PARAGRAPH,
    },
  ],
  data: {},
  nodeType: BLOCKS.DOCUMENT,
} as Document

const MeasureUserActions = () => (
  <SectionBase variant="2Col" reverse={true}>
    <SectionCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
        <RichText data={description} />
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <picture>
        <source
          type="image/webp"
          srcSet={`${AutomaticallyMeasureWebp}, ${AutomaticallyMeasureWebp2x} 2x, ${AutomaticallyMeasureWebp3x} 3x`}
        />
        <StyledImage
          src={AutomaticallyMeasurePng2x}
          alt="Illustration: Measure User Actions"
          width="640"
          height="619"
          loading="lazy"
        />
      </picture>
    </Section.Contents>
  </SectionBase>
)

const StyledImage = styled(Image)`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

export default MeasureUserActions
